export default __webpack_public_path__ + "static/twitter-efb1d25090182d64a072ca490e86842f.svg";